import { CssType, ThemeType } from 'src/theme/jss-types';
import { NAVBAR_HEIGHT } from '../../../globals';

export const ISTDetailsStyles = (theme: ThemeType): CssType => ({
    mainDiv: {
        flex: '1 1 0',
        padding: '0 16px 16px 16px',
        height: `calc( 100vh - ${NAVBAR_HEIGHT}px)`,
    },
    backAndSearch: {
        margin: '20px 10px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    title: {
        fontSize: '15px',
        fontWeight: 600,
        cursor: 'pointer',
    },
    icons: {
        margin: '0px 5px',
        cursor: 'pointer',
    },
    container: {
        padding: '15px 12px',
        margin: '10px 12px',
        backgroundColor: '#ffffff',
        border: '1px solid #D9D9D9',
        borderRadius: '4px',
    },
    hint: {
        fontSize: '12px',
        color: '#595959',
        fontWeight: 400,
        margin: '12px 0',
    },
    content: {
        fontSize: '14px',
        color: '#262626',
        fontWeight: 500,
    },
    lightenLabel: {
        color: '#595959',
        paddingTop: 3,
        fontSize: 11,
    },
    refreshButton: {
        padding: '0 8px',
        marginLeft: 10,
    },
    tableContainer: {
        background: 'white',
        '& .ant-btn': {
            marginLeft: 5,
        },
        margin: '20px 12px',
        flexGrow: 1,
        overflowY: 'scroll',
        height: '80vh',
    },
    cameraIcon: {
        marginLeft: 10,
        color: '#085492',
    },
    actionButton: {
        marginLeft: 10,
    },
    status: {
        textTransform: 'capitalize',
    },
    leftSpace: {
        marginRight: '5px',
    },
    circle: {
        display: 'inline-block',
        borderRadius: '100%',
        marginRight: '5px',
        height: '12px',
        width: '12px',
    },
    checkedInCircle: {
        backgroundColor: '#EAAB0B',
    },
    checkedOutCircle: {
        backgroundColor: '#56D001',
    },
    secondaryStopTable: {
        margin: '15px 0',
    },
    red: {
        backgroundColor: '#FF7979',
    },
    green: {
        backgroundColor: '#c1e0d1',
    },
    infoIcon: {
        marginLeft: '8px',
        color: '#085492',
    },
    verticalSpacing: {
        marginTop: '0.5rem',
    },
});
